import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./toastMessage.html";
import { INTERNAL_SERVER_ERROR } from '../utils/appConstants';
class ToastMessage extends LightningElement {
  constructor(...args) {
    super(...args);
    this.statusMessage = '';
    this.openToastMessage = statusMessage => {
      this.statusMessage = statusMessage;
      this.template.querySelector('div[data-my-id="toastMessageDiv"]').style.display = 'block';
    };
    this.closeToastMessage = () => {
      this.template.querySelector('div[data-my-id="toastMessageDiv"]').style.display = 'none';
    };
    this.openToastErrorMessage = (statusMessage, isHideMoreInfo) => {
      this.statusMessage = statusMessage;
      if (isHideMoreInfo) {
        this.template.querySelector('a[data-my-id="moreInformation"]').className = 'more-info-msg_hide';
      }
      this.template.querySelector('div[data-my-id="toastErrorMessageDiv"]').style.display = 'block';
      if (statusMessage.includes(INTERNAL_SERVER_ERROR)) {
        this.template.querySelector('a[data-my-id="moreInformation"]').style.display = 'none';
      }
    };
    this.closeToastErrorMessage = () => {
      this.template.querySelector('div[data-my-id="toastErrorMessageDiv"]').style.display = 'none';
    };
    this.showModalView = () => {
      const errormodal = new CustomEvent('showerrormodal', {});
      this.dispatchEvent(errormodal);
      this.closeToastErrorMessage();
    };
  }
}
_registerDecorators(ToastMessage, {
  publicProps: {
    openToastMessage: {
      config: 0
    },
    closeToastMessage: {
      config: 0
    },
    openToastErrorMessage: {
      config: 0
    },
    closeToastErrorMessage: {
      config: 0
    }
  },
  fields: ["statusMessage", "showModalView"]
});
export default _registerComponent(ToastMessage, {
  tmpl: _tmpl
});